import type { ProjectFilters, TaskFilters } from "@tunic/shared";

export const qk = {
  me: ["me"] as const,
  config: ["config"] as const,
  now: ["now"] as const,
  team: ["team"] as const,
  users: ["users"] as const,
  tokens: ["tokens"] as const,
  inbox: ["inbox"] as const,
  projects: {
    all: ["projects"] as const,
    list: (f: ProjectFilters) => ["projects", "list", f] as const,
    detail: (id: string) => ["projects", id] as const,
    steps: (id: string) => ["projects", id, "steps"] as const,
    tasks: (id: string, f?: TaskFilters) => ["projects", id, "tasks", f ?? {}] as const,
    sources: (id: string) => ["projects", id, "sources"] as const,
    events: (id: string) => ["projects", id, "events"] as const,
    brief: (id: string) => ["projects", id, "brief"] as const,
  },
  tasks: { list: (f: TaskFilters) => ["tasks", f] as const },
  events: { all: ["events"] as const },
  reports: { list: ["reports"] as const, detail: (id: string) => ["reports", id] as const },
  chat: {
    threads: (projectId?: string | null) => ["chat", "threads", projectId ?? "*"] as const,
    messages: (id: string) => ["chat", "messages", id] as const,
  },
};
